module.exports = __webpack_public_path__ + "static/media/SuperShuttle_android_2.1229c665.jpg";